module.exports = __webpack_public_path__ + "img/training2.7326cdb8.png";